import { Action } from '../actions';
import { ActionType } from '../actions/shipment-group';
import { ActionType as TruckActionType } from '../actions/truck';
import { ShipmentGroupConfigurationsState, InternalShipmentGroupsState } from '../state/shipment-group';
import { InternalShipmentGroup, ShipmentGroupConfiguration } from '../../models/shipment-group';
import { Dictionary } from '../../models/utils';

const defaultState = {
  all: {} as Dictionary<any>,
  isLoading: false,
};

export function internalShipmentGroupsReducer(
  state: InternalShipmentGroupsState = defaultState,
  action: Action,
): InternalShipmentGroupsState {
  switch (action.type) {
    case ActionType.GET_INTERNAL_SHIPMENT_GROUPS_REQUEST:
      return {
        ...state, isLoading: true,
      };

    case ActionType.GET_INTERNAL_SHIPMENT_GROUPS_FAILURE:
      return {
        ...state, isLoading: false,
      };

    case ActionType.GET_INTERNAL_SHIPMENT_GROUPS_SUCCESS:
      const { data } = action;
      const all: Dictionary<InternalShipmentGroup> = {};
      data.forEach(sg => all[sg.id] = sg);
      return {
        all,
        isLoading: false,
      };

    case TruckActionType.LOAD_TRUCK_SUCCESS:
      return {
        ...state,
        all: {
          ...state.all,
          [action.data.internalShipmentGroup.id]: {
            ...state.all[action.data.internalShipmentGroup.id],
            shipmentCount: 0,
          },
        },
      };

    case TruckActionType.LOAD_SHIPMENT_GROUP_SUCCESS: {
      const all = {
        ...state.all,
      };

      action.data.shipmentGroup.internalShipmentGroups.forEach(
        internalShipmentGroup => {
          all[internalShipmentGroup.id] = {
            ...all[internalShipmentGroup.id],
            shipmentCount: 0,
          };
        },
      );

      return {
        ...state,
        all,
      };
    }

    default:
      return state;
  }
}

export function shipmentGroupConfigurationsReducer(
  state: ShipmentGroupConfigurationsState = defaultState,
  action: Action,
): ShipmentGroupConfigurationsState {
  switch (action.type) {
    case ActionType.GET_SHIPMENT_GROUP_CONFIGURATIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case ActionType.GET_SHIPMENT_GROUP_CONFIGURATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case ActionType.GET_SHIPMENT_GROUP_CONFIGURATIONS_SUCCESS: {
      const all: Dictionary<ShipmentGroupConfiguration> = {};
      for (const shipmentGroupConfiguration of action.data) {
        all[shipmentGroupConfiguration.id] = shipmentGroupConfiguration;
      }
      return {
        all,
        isLoading: false,
      };
    }

    case ActionType.CREATE_SHIPMENT_GROUP_CONFIGURATION_SUCCESS:
      return {
        isLoading: false,
        all: {
          ...state.all,
          [action.data.id]: action.data,
        },
      };

    case ActionType.UPDATE_SHIPMENT_GROUP_CONFIGURATION_SUCCESS:
      return {
        isLoading: false,
        all: {
          ...state.all,
          [action.data.id]: action.data,
        },
      };

    case ActionType.DELETE_SHIPMENT_GROUP_CONFIGURATION_SUCCESS: {
      const all: Dictionary<ShipmentGroupConfiguration> = {};
      for (const [id, shipmentGroupConfiguration] of Object.entries(state.all)) {
        if (id !== action.data) {
          all[id] = shipmentGroupConfiguration;
        }
      }
      return {
        ...state,
        all,
      };
    }
  }
  return state;
}
